import http from '@/support/plugin/axios'

export const 

insertContactByCompanyId = ( companyId, insertUserObj ) => http.post(`companies/${companyId}/contacts`, insertUserObj),

getPendingReviewsByCurrentContactIdAndCompanyId = ( companyId ) => http.get(`/companies/${companyId}/contacts/current/pending-reviews`),

getLastPointByCompanyIdAndContactTelephone = ( companyId, contactTelephone ) => http.get(`companies/${companyId}/contacts/last-point?contactTelephone=${contactTelephone}`),

// buscarCidadeIntegracao = (search ) => http.get(`sankhya/cities?search=${search}`),
buscarCidadeIntegracao = (estado, search ) => http.get(`/city/stateId?stateId=${estado}&search=${search}`), 

buscarEstado = () => http.get(`/state`);